import React from "react";
import { connect } from "react-redux";
import { History } from "history";
import { FormattedMessage, injectIntl } from "react-intl";
import _ from "lodash";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import SearchInput from "components/SearchInput";
import Button from "components/Button";
import { getColumns } from "./columns";
import { URLS } from "constants/urlConstants";
import NotificationsActions from "./actions";
import { INotification, ICommonState, IMeta } from "models/.";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  history: History;
  meta: IMeta;
  match: any;
  local: string;
  getNotifications: (meta?: IMeta) => void;
  notifications: INotification[];
  onRemove: (ids: string[]) => void;
  intl: any;
}

class MyNotifications extends React.Component<IProps, ICommonState> {
  constructor(props) {
    super(props);

    this.state = {
      searchString: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {}
    };
  }

  public componentDidMount() {
    const { meta, getNotifications } = this.props;

    getNotifications();

    if (meta && meta.searchString) {
      this.setState({
        searchString: meta.searchString
      });
    }
  }

  private handleSearchChange = e => {
    const searchString = e.target.value;

    this.setState({ searchString }, this.search);
  };

  private search = _.debounce(() => {
    const { meta, getNotifications, local } = this.props;
    const { searchString } = this.state;

    getNotifications({ ...meta, searchString, local });
  }, 500);

  private handleSelect = () => {
    const ids = _.keys(this.state.checkedRows);
    this.props.onRemove(ids);
  };

  private handleFieldChooser = () => {
    this.setState(prevState => ({
      showFieldChooser: !prevState.showFieldChooser
    }));
  };

  private handleFieldsChange = columnsCopy => this.setState({ columnsCopy });

  private onRowSelect = checkedRows => this.setState({ checkedRows });

  public render() {
    const {
      showFieldChooser,
      columnsCopy,
      searchString,
      checkedRows
    } = this.state;
    const {
      history,
      notifications,
      local,
      meta,
      intl: { formatMessage },
      getNotifications
    } = this.props;

    return (
      <div id="my-notifications-page">
        <div className="child-header">
          <FormattedMessage id="NOTIFICATIONS" tagName="h1" />
          <Button
            kind="primary"
            className="animate-bg bg-white"
            onClick={() => history.push(`${URLS.MY_NOTIFICATIONS_URL}/new`)}
          >
            NOTIFICATIONS_ADD
          </Button>
        </div>
        <SearchInput
          placeholder="NOTIFICATIONS_SEARCH"
          onChange={this.handleSearchChange}
          value={searchString}
        />
        <TopButtons
          options={[
            { value: "Delete", label: formatMessage({ id: "REMOVE" }) }
          ]}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          entityName="notifications"
        />
        <Table
          meta={meta}
          columns={columnsCopy}
          dataSource={notifications}
          onRowClick={({ _id }) =>
            history.push(`${URLS.MY_NOTIFICATIONS_URL}/${_id}`)
          }
          keyPath="_id"
          onQueryChange={getNotifications}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.myNotifications}
        />
        <FieldChooser
          name="myNotifications"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={getColumns(local)}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    notifications: state.notifications.items,
    meta: state.notifications.meta,
    local: state.app.user.profile.Language
  }),
  {
    getNotifications: NotificationsActions.getNotifications,
    onRemove: NotificationsActions.removeNotifications
  }
)(injectIntl(MyNotifications));
